import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'antd';
import Box from '../../components/Box';
import Header from './components/Header';

import constructionPropTypes from './components/Header/Header.types';

import {
  Container,
  ConstructionsWrapper
} from './ConstructionHeader.styles';
import { useTranslation } from "../../contexts/TranslationContext";

const ConstructionHeader = ({
                              activeConstruction = null,
                              constructions,
                              onConstructionChange,
                            }) => {
  const translationsData = useTranslation();

  return (
    <Container>
      <Container>
        <Box
          noTop
          clear
          loading={activeConstruction === null}
          loaderHeight={208}
          wide
        >
          <ConstructionsWrapper>
            <Breadcrumb
              style={{ margin: '16px 0' }}
              items={[
                {
                  title: translationsData.garage_type || "garage_type"
                }
              ]}
            />
            {activeConstruction ? (
              <Header
                constructions={constructions}
                activeConstruction={activeConstruction}
                onConstructionChange={onConstructionChange}
              />
            ) : null}
          </ConstructionsWrapper>
        </Box>
      </Container>
    </Container>
  );
};

ConstructionHeader.propTypes = {
  constructions: PropTypes.arrayOf(constructionPropTypes).isRequired,
  onConstructionChange: PropTypes.func.isRequired,
  activeConstruction: PropTypes.number,
};

export default ConstructionHeader;
